<template>
  <UseVirtualList class="vinko-scrollbar " :list="data" :options="{itemHeight}" :height="height">
    <template #="{data: dataRow, index: rowIndex}">
      <n-grid :cols="cols">
        <template v-for="field in fields" :key="field.key+ rowIndex">
          <n-gi :span="field.span ?? 1" class="border-b border-b-secondary my-2">
            <slot :name="field.key" v-bind="dataRow">
              <!-- This is the default if slot is not provided -->
              <div>{{ dataRow[field.key] }}</div>
            </slot>
          </n-gi>
        </template>
      </n-grid>
    </template>
  </UseVirtualList>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import { UseVirtualList } from "@vueuse/components"
import { NSpace, NGrid, NGi } from "naive-ui";

const props = defineProps({
  hideHeader: { type: Boolean, default: false },
  itemHeight: { type: Number, default: 100 },
  height: { type: String, default: "300px" },
  fields: {
    type: Array as PropType<
      Array<{
        key: string;
        label: string;
        span?: number;
      }>
    >,
    required: false,
  },
  data: {
    type: Array as PropType<Array<{ [key: string]: any }>>,
    required: true,
  },
});

const cols = computed(() => props.fields?.reduce((p, v) => p + (v.span ?? 1), 0) ?? 1);
</script>

<style lang="postcss" scoped>
.row {
  border-bottom: 0.5px solid black;
  @apply h-10 border-b-secondary;

  th,
  td {
    @apply text-start;
  }

  th {
    @apply text-gray-500;
  }
}

.col-grow {
  @apply flex-grow w-full text-start;
}
</style>
